import { Search, X } from 'lucide-react';
import { SearchField } from 'react-aria-components';
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from '../tailgrids/core/input-group.js';
import { cn } from '../../utils/cn.js';

interface SearchBarProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  /** Names the field for screen readers; defaults to the placeholder. */
  'aria-label'?: string;
  className?: string;
}

/** The list-toolbar search box (NextAdmin input group on react-aria `SearchField`): Escape or ✕ clears it. */
export function SearchBar({ value, onChange, placeholder = 'Search…', className, ...aria }: SearchBarProps) {
  return (
    <SearchField
      value={value}
      onChange={onChange}
      aria-label={aria['aria-label'] ?? placeholder}
      className={cn('w-full sm:w-64', className)}
    >
      <InputGroup>
        <InputGroupAddon>
          <Search size={15} className="text-muted" aria-hidden="true" />
        </InputGroupAddon>
        <InputGroupInput placeholder={placeholder} className="py-2 text-sm [&::-webkit-search-cancel-button]:hidden" />
        {value && (
          <InputGroupButton size="icon-sm" className="mr-1" aria-label="Clear search">
            <X size={14} />
          </InputGroupButton>
        )}
      </InputGroup>
    </SearchField>
  );
}
